import {
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@heidi/design-system/dropdown-menu';
import { TypographyCaption, TypographyP2 } from '@heidi/design-system/typography';
import { useTranslations } from '@heidi/runtime/i18n';
import { ChevronRight, UserRound } from 'lucide-react';
import { usePatientProfileFilter } from './hooks/usePatientProfileFilter';
import { PatientProfileFilterPicker } from './patient-profile-filter-picker';

export const PatientProfileFilter = () => {
  // Pass enabled:false so the fetch stays lazy; the hook's own isOpen (wired
  // to the sub-menu below) triggers it on open, and selected.length>0 keeps
  // it live when a prior selection exists.
  const { selectedPatientProfilesFilter, isOpen, setIsOpen } = usePatientProfileFilter({
    enabled: false,
  });
  const { t } = useTranslations();

  return (
    <DropdownMenuSub open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuSubTrigger
        hideChevron
        className="items-center justify-between gap-2 py-1.5 pl-2.5 pr-1.5"
      >
        <div className="flex items-center gap-2">
          <UserRound size={16} className="min-w-4" />
          <div className="flex flex-col justify-center gap-0.5">
            <TypographyP2>{t('patient.patientProfile')}</TypographyP2>
            {selectedPatientProfilesFilter.length > 0 && (
              <TypographyCaption className="text-text-secondary">
                {selectedPatientProfilesFilter.length}{' '}
                {t('sessionToolbar.filters.selected')}
              </TypographyCaption>
            )}
          </div>
        </div>
        <ChevronRight
          size={16}
          className="min-w-4 text-text-secondary rtl:-scale-x-100"
        />
      </DropdownMenuSubTrigger>
      <DropdownMenuPortal>
        <DropdownMenuSubContent sideOffset={4} className="w-screen max-w-[256px]">
          <PatientProfileFilterPicker enabled={isOpen} />
        </DropdownMenuSubContent>
      </DropdownMenuPortal>
    </DropdownMenuSub>
  );
};
